export const DASHBOARD_VISIBLE_CARDS = {
  jobsCount: [
    'total',
    'Total Jobs',
    'active',
    'Active Jobs',
    'myAssignedCount',
    'My Jobs',
  ],
  submissionCount: [
    'Selected',
    'Submitted to client',
    'Submitted to Client',
    'Not Submitted',
    'Approved',
  ],
  // onboardingCount: [
  //   'inProgress',
  //   'In Progress',
  //   'hired',
  //   'Hired',
  //   'projectCompleted',
  //   'Project Completed',
  //   'archive',
  //   'Archive',
  // ],
};

export function visibleCardsFor(moduleName) {
  return DASHBOARD_VISIBLE_CARDS[moduleName] ?? null;
}
